import { Position } from '@xyflow/react';
import { ERFElement } from '../../../enums';
import { L_FLOW_HEX, M_FLOW_HEX } from '../../../constants';
export const ENGINE_TEST_SYNTHETIC_CONFIG = {
    type: ERFElement.EngineTestSynthetic,
    templates: [
        {
            code: 'default',
            ports: [
                {
                    id: 'target_material_multiport',
                    type: 'target',
                    name: 'Входной мультипорт',
                    position: Position.Left,
                    style: { top: 26, left: 9, background: M_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_material_multiport',
                    type: 'source',
                    name: 'Выходной мультипорт',
                    position: Position.Right,
                    style: { top: 26, right: 9, background: M_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                /* PORTS FOR LOGICAL ELEMENTS */
                {
                    id: 'target_logical_flow',
                    type: 'target',
                    name: 'Входные параметры',
                    position: Position.Left,
                    style: { top: 48, left: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                },
                {
                    id: 'source_logical_flow',
                    type: 'source',
                    name: 'Выходные параметры',
                    position: Position.Right,
                    style: { top: 48, right: 9, background: L_FLOW_HEX },
                    connectionCount: Number.MAX_SAFE_INTEGER
                }
            ]
        }
    ]
};
//# sourceMappingURL=RFEngineTestSyntheticNode.config.js.map